import { OrderSetupStatusEnum } from "Infrastructure/Api/Api";
import type {
	EditForm,
	Mutation,
	OrderSetupTranslations,
	Shared,
} from "Infrastructure/Translation/Types/orderSetup";

const mutationTranslations: Mutation = {
	createOrderSetupError: "Error creating order setup.",
	createOrderSetupSuccess: "Order setup created successfully.",
	updateOrderSetupError: "Error updating order setup.",
	updateOrderSetupSuccess: "Order setup updated successfully.",
	deleteOrderSetupError: "Error deleting order setup.",
	deleteOrderSetupSuccess: "Order setup deleted successfully.",
};

const editFormTranslations: EditForm = {
	name: "Name",
	status: "Status",
	key: "Key",
	label: "Label",
	type: "Type",
	value: "Value",
	addOrderField: "Add Order Field",
	saveSetup: "Save Setup",
	deploySetup: "Deploy",
	deployedStatus: "Deployed",
	orderFields: "Order Fields",
	saveOptions: "Save",
	cancel: "Cancel",
	optionsTitle: "Enum Options",
	optionsDescription: "Add or edit options",
	addOption: "Add option",
	removeOption: "Remove option",
};

const sharedTranslations: Shared = {
	addSetup: "Add Setup",
	selectMarketToEdit: "Select market to edit",
	orderSetup: "All setups",
	deployedSetup: "Deployed setup",
	verticals: "Verticals",
	indexPageTitle: "Order Setup Page",
	indexPageDescription: "Manage your order setup.",
	editPageTitle: "Edit Order Setup",
	editPageDescription: "Modify your order setup here.",
	noResults: "No order setups available",
	deployed: "Current version is deployed",
	noDeployment: "No version has been deployed",
	statuses: {
		[OrderSetupStatusEnum.draft]: "Draft",
		[OrderSetupStatusEnum.ready]: "Ready",
		[OrderSetupStatusEnum.deployed]: "Ready",
	},
	redirectToOrderSetup: "Go to order setup",
	confirmationTitle: "Confirmation",
	deleteConfirmation: "Are you sure you want to delete this setup?",
	deleteSetup: "Delete",
	cancel: "Cancel",
};

const validationMessagesTranslations = {
	orderFieldsNonEmpty: "At least one field is required.",
};

export const orderSetupTranslations: OrderSetupTranslations = {
	mutation: mutationTranslations,
	editForm: editFormTranslations,
	shared: sharedTranslations,
	validationMessages: validationMessagesTranslations,
};
